import React from 'react'

const ListRatesLabel: React.FC<{
    carrierIdentifier: string
}> = ({ carrierIdentifier }) => {
    const label =
        carrierIdentifier === 'ups'
            ? 'Published Daily Rates'
            : 'Standard List Rates'

    return (
        <div>
            <span className="rate-type">{label}</span>
        </div>
    )
}

interface Props {
    carrier?: Partial<Carrier>
}

const ValidationStatus: React.FC<{
    carrier: Carrier
}> = ({
    carrier: {
        id,
        installed,
        validated,
        carrier_type,
        name,
        list_rates = false,
    } = {},
}: Props) => {
    const carrierIsInstalled = installed || id
    // sometimes the fields are missing, so we just need something
    // that can identify the carrier. Type is the best identifier
    // next is name
    const carrierIdentifier = carrier_type || name

    // Only show for UPS and FedEx when list_rates is true
    if (
        list_rates &&
        carrierIsInstalled &&
        (carrierIdentifier === 'ups' || carrierIdentifier === 'fedEx')
    ) {
        return <ListRatesLabel carrierIdentifier={carrierIdentifier} />
    }

    if (!validated && carrierIsInstalled) {
        return (
            <div className="creds-warning">
                Needs Credentials <i className="fas fa-circle" />
            </div>
        )
    }

    return null
}

export default ValidationStatus
